type EnvKey = "NODE_ENV" | "REACT_APP_API_URL";

export const getEnv = (key: EnvKey): string => {
  const value = process.env[key];

  if (value !== undefined) return value;

  throw new Error(`ENV variable "${key}" is not defined.`);
};
